/* prettier-ignore */
const uaJSON = {
  '(optional)': "(необов'язково)",
  '% of Total': '% від загальної суми',
  'Activities by type': 'Діяльність за видами',
  "Activities completed by member": "Дії, виконані учасником",
  "Activities completed by professional": "Діяльність виконана професіоналом",
  'Activities summary': 'Підведення підсумків діяльності',
  'Add a note explaining your decision': 'Додайте примітку, пояснюючи своє рішення',
  'After date': 'Після дати',
  'Agree & submit': 'Погодьтеся та надішліть',
  'Agreed on decision and moved to closed': 'Погодили рішення та перейшли до закритого',
  'Already have an account?': 'Вже є аккаунт?',
  'already reviewed': 'вже переглянуто',
  'Apply filter': 'Застосувати фільтр',
  'Asset Type': "Тип активу",
  'Average time to resolve a submission marked for action': 'Середній час вирішення подання, позначеного для виконання',
  'Average time to resolve': 'Середній час вирішення',
  'Bad parking': 'Погана парковка',
  'Before date': 'До дати',
  'Between dates': 'Між датами',
  'Bulk actions': 'Масові дії',
  'Cannot move records to Capture stage': 'Неможливо перемістити записи на етап захоплення',
  'Captur Dashboard': 'Інформаційна панель Captur',
  'Capture': 'захоплення',
  'Check your email for further instructions': "Перевірте свою електронну пошту, щоб отримати подальші інструкції",
  'Clear filter': 'Очистити фільтр',
  'Click here': 'Натисніть тут',
  'Compared to previous period': 'Порівняно з попереднім періодом',
  'Continue to login': 'Продовжити вхід',
  'Copied!': 'Скопійовано!',
  'Copy to clipboard': 'Копіювати в буфер обміну',
  'Count of all records in Action stage. These should be actioned as soon as possible': 'Кількість усіх записів на етапі дії. Ці дії слід вжити якомога швидше',
  'Count of all records in Closed stage. No further action is required': 'Кількість усіх записів на закритій стадії. Ніяких додаткових дій не потрібно',
  'Count of all records in Review stage. These should be reviewed and either flagged for Action or moved to Closed': 'Кількість усіх записів на етапі перегляду. Їх слід переглянути та позначити як «Дія» або перемістити в «Закрито».',
  'Count of all records': 'Підрахунок усіх записів',
  'Create account': 'Створити акаунт',
  'Create record': 'Створити запис',
  'Dark colour themes': 'Темні кольорові теми',
  'Dashboards': 'Приладові панелі',
  'Decision changed and moved to closed': 'Рішення змінено та закрито',
  'Decision changed': 'Рішення змінено',
  'Decision note is required': 'Потрібна записка про рішення',
  'Decision note': 'Записка про рішення',
  'Delete this record': 'Видалити цей запис',
  'Drag & drop files here': 'Перетягніть файли сюди',
  'Drop the files to start uploading': 'Відпустіть файли, щоб почати завантаження',
  'Edit record': 'Редагувати запис',
  'Email is required': "Необхідно вказати адресу електронної пошти",
  'Email': 'Електронна пошта',
  'Enter the email used for registration to reset your password': "Введіть адресу електронної пошти, яку використовували для реєстрації, щоб скинути пароль",
  'files uploaded': 'завантажених файлів',
  'Fill in the fields below to sign into your account': 'Заповніть поля нижче, щоб увійти у свій обліковий запис',
  'Filter records': 'Фільтрувати записи',
  'Filter search': 'Фільтр пошуку',
  'Good parking': 'Гарна парковка',
  'I accept the terms and conditions': "Я приймаю положення та умови",
  'Images are being uploaded': 'Зображення завантажуються',
  'Improvable parking': 'Покращена парковка',
  'Individual productivity': 'Індивідуальна продуктивність',
  'Insufficient information': 'Недостатньо інформації',
  'Label': 'Мітка',
  'Language Switcher': 'Перемикач мов',
  'Last 30 days': 'Останні 30 днів',
  'Last 7 days': 'Останні 7 днів',
  'Last 90 days': 'Останні 90 днів',
  'Light colour themes': 'Світлі кольорові теми',
  'Location on map not available': 'Розташування на карті недоступне',
  'Lost password?': 'Втрачений Пароль?',
  'Manage the day to day tasks for your workspace': 'Керуйте повсякденними завданнями для свого робочого простору',
  'Move to Action': 'Перейти до дії',
  'Move to Closed': 'Перейти до Закрито',
  'Move to Review': 'Перейти до огляду',
  'Must be at least 10 characters': 'Має бути не менше 10 символів',
  'New records to review': 'Нові записи для перегляду',
  'No changes applied as records already match stage': 'Жодних змін не застосовано, оскільки записи вже відповідають етапу',
  'No image': 'Немає зображення',
  'No previous results': 'Немає попередніх результатів',
  'No vehicle in image': "На зображенні немає транспортного засобу",
  'Number is required': 'Необхідно вказати номер',
  'Number of records submitted in current period': 'Кількість поданих записів у поточному періоді',
  'On date': 'На дату',
  'on last period': 'на минулому періоді', 
  'Password is required': 'Необхідно ввести пароль',
  'Password': 'Пароль',
  'Poor image quality': 'Погана якість зображення',
  'Poorly parked': 'Погано припаркований',
  'Post ride': 'Поштова поїздка',
  'Previous period': 'Попередній період',
  'Privacy Policy': 'Політика конфіденційності',
  'Proof of Delivery': 'Докази поставки',
  'Record details': 'Деталі запису',
  'Record list': 'Список записів',
  'Record productivity summary': 'Запис продуктивності' ,
  'Record summary': "Резюме запису",
  'Record types': 'Типи записів',
  'Records - Management': 'Записи - Управління',
  'Records to review': 'Записи для перегляду',
  'Records with at least one tag': 'Записи з принаймні одним тегом',
  'Recover Password': 'Відновити пароль',
  'Reset search': 'Скинути пошук',
  'Review records': 'Перегляньте записи',
  'Reviews and decisions made by team members': 'Огляди та рішення, прийняті членами команди',
  'Rows per page': 'Рядків на сторінці',
  'Search ...': 'пошук...',
  'Search for exact match on number only': 'Шукайте точну відповідність лише за номером',
  'Select decisions...': 'Виберіть рішення...',
  'Select labels...': 'Виберіть мітки...',
  'Select record type': 'Виберіть тип запису',
  'Send me a new password link': 'Надішліть мені посилання для нового пароля',
  'Set decision': 'Встановити рішення',
  'Sign in here': 'Увійдіть тут',
  'Sign in': "Увійти",
  'Sign out': 'Вийти з аккаунта',
  'Sign up here': 'Зареєструйтеся тут',
  'Sign up without a workspace is not supported. Please contact your workspace administrator for signup instructions': "Реєстрація без робочої області не підтримується. Будь ласка, зверніться до свого адміністратора робочої області, щоб отримати інструкції щодо реєстрації",
  'Skip': 'Пропустити',
  'Start reviewing': 'Розпочати огляд',
  'Submissions Summary': 'Резюме подання',
  'Submit change': 'Надіслати зміни',
  'Submitted by role': 'Надіслано за роллю',
  'Submitted by': 'Представлений',
  'Submitted date': 'Дата подання',
  'Tags/Labels': 'Теги/мітки',
  'Team Productivity': 'Продуктивність команди',
  'Terms of Service': "Умови використання",
  'The email provided should be a valid email address': 'Надана електронна адреса має бути дійсною',
  'The password reset instructions have been sent to your email': "Інструкції щодо зміни пароля надіслано на вашу електронну адресу",
  'Theme Settings': 'Налаштування теми',
  'Too close up': 'Занадто близько',
  'Too far away': 'Занадто далеко',
  'Total records submitted': 'Загальна кількість поданих записів',
  'Total submissions': 'Усього поданих',
  'View all': 'Подивитись все',
  'View help': 'Переглянути довідку',
  'Volume of activity created': 'Обсяг створеної діяльності',
  'Volume of issue activity created': 'Обсяг створеної емісійної діяльності',
  'Volume of submissions and their decision outcomes': 'Обсяг подань та результати їх вирішення',
  'Want to try to sign in again?': 'Хочете спробувати ввійти знову?',
  'Weather conditions': 'Метеорологічні умови',
  'You cannot upload these file types': 'Ви не можете завантажити ці типи файлів',
  'You have been invited to join Captur.':"Вас запросили приєднатися до Captur.",
  'You have provided an invalid email and password combination': 'Ви вказали недійсну комбінацію електронної пошти та пароля',
  'You must agree to our terms and conditions': 'Ви повинні погодитися з нашими умовами',
  "Don’t have an account yet?": "У вас ще немає облікового запису?",
  Action: 'Дія',
  Actions: 'Дії',
  active: 'активний',
  Active: 'Активний',
  Activities: 'Діяльності',
  Admin: 'адмін',
  All: 'все',
  Analytics: 'Аналітика',
  Approved: 'Затверджено',
  Archived: 'Архівовано',
  Audit: 'Аудит',
  Back: 'Назад',
  Blocked: 'заблоковано',
  Blocking:'Блокування',
  Cancel: 'Скасувати',
  Changed: "Змінено.",
  Close: 'Закрити',
  Closed: 'ЗАЧИНЕНО',
  Confirm: 'Підтвердити',
  Created: 'Створено',
  current: 'поточний',
  Custom: 'звичай',
  Customer: 'клієнт',
  Daily: 'Щодня',
  dashboard: 'панель приладів',
  Data: 'Дані',
  days: 'днів',
  Decision: 'Рішення',
  Decisions: 'Рішення',
  Delete: 'Видалити',
  Descriptor: "Дескриптор",
  Details: 'Подробиці',
  Download: 'Завантажити',
  Hello: 'Привіт',
  History: 'історія',
  Home: 'додому',
  hours: 'години',
  inactive: 'неактивний',
  Inactive: 'Неактивний',
  Invited: 'Запрошений',
  Issues: 'Питання',
  Labels: 'етикетки',
  Language: 'Мова',
  Location: 'Місцезнаходження',
  Locations: 'Розташування',
  Login: 'Логін',
  Map: 'Карта',
  Member: 'член',
  minutes: 'хвилин',
  Monthly: 'Щомісяця',
  New: 'новий',
  No: 'Немає',
  Notes: 'Примітки',
  Number: 'Номер',
  On: 'Увімкнено',
  Pending: 'В очікуванні',
  prediction: 'передбачення',
  Previous: 'Попередній',
  Professional: 'професійний',
  Public: 'громадськість',
  records: 'записи',
  Records: 'Записи',
  Reports: 'Звіти',
  review: 'огляд',
  Save: 'зберегти',
  Search: 'Пошук',
  seconds: 'секунд',
  Settings: 'Налаштування',
  Showing: 'Показ',
  Stage: 'етап',
  State: 'Держава',
  Submitted: 'Надіслано',
  Subscribed: 'Підписався',
  Tags: 'Теги',
  Theme: 'Тема',
  Today: 'Сьогодні',
  Total: 'Всього',
  Type: 'Тип',
  Version: 'Версія',
  Welcome: 'Ласкаво просимо',
  Workspace: 'Робоча область',
  Yes: 'Так',
  Zone: 'Зона',
  "Decisions made by Captur's models and customer support across all related workspaces": "Рішення, прийняті моделями Captur, і підтримка клієнтів у всіх пов’язаних робочих областях",
  Members: 'Члени',
  'Control Centre': 'Центр управління',
  'Submissions made': 'Подано',
  'Total number of submissions made during the selected time period': 'Загальна кількість повідомлень, зроблених протягом вибраного періоду часу',
  'Decision split': 'Розділ рішення',
  'Breakdown of decisions over the selected period': 'Розподіл рішень за вибраний період',
  'Good delivery': 'Гарна доставка',
  'Improvable delivery': 'Покращена доставка',
  'Bad delivery': 'Погана доставка',
};

export default uaJSON;
